import { render, staticRenderFns } from "./DiffSpend.vue?vue&type=template&id=16ecc902"
import script from "./DiffSpend.vue?vue&type=script&lang=js"
export * from "./DiffSpend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports